import React from 'react';
import ActiveTasksTable from './ActiveTasksTable';

function ActiveTasks() {

    return (
        <ActiveTasksTable />
    );
}

export default ActiveTasks;
